import { createFileRoute } from '@tanstack/react-router';
import { ArticleEditorPage } from '@/pages/member-portal/articles/ArticleEditorPage';

function MemberPortalManageAboutRoute() {
	return <ArticleEditorPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/about')({
	component: MemberPortalManageAboutRoute,
});
